import {useStaticQuery, graphql} from 'gatsby';

interface SeoQueryResult {
	site: {
		siteMetadata: {
			siteTitle: {
				ar: string;
				en: string;
			};
			siteDescription: {
				ar: string;
				en: string;
			};
			siteAuthor: {
				ar: string;
				en: string;
			};
			social: {
				twitter: string;
			};
		};
	};
}

export function useSeoQuery(): SeoQueryResult {
	return useStaticQuery<SeoQueryResult>(
		graphql`
			query {
				site {
					siteMetadata {
						siteTitle {
							ar
							en
						}
						siteDescription {
							ar
							en
						}
						siteAuthor {
							ar
							en
						}
						social {
							twitter
						}
					}
				}
			}
		`,
	);
}
